module.exports = __webpack_public_path__ + "static/media/instructivo3.59e0a468.png";